<template>
  <ArendeSection :heading="heading">
    <ArendeItem
      v-for="(arende, index) in props.arenden"
      :key="index"
      :arende="arende"
      :url="composeArbetsgivareArendetUrl(arende.id)"
    />
    <avtalat-button
      class="shrink self-center text-base"
      id="show-more-arenden"
      v-if="props.canShowMore"
      v-on:click="props.showMore"
      outlined
      :loading="props.isLoading"
      >{{ showMoreTicketsButtonLabel }}</avtalat-button
    >
    <div v-if="props.arenden.length === 0">
      Det finns inga <span class="lowercase">{{ heading }}</span>
    </div>
  </ArendeSection>
</template>
<script setup lang="ts">
import { composeArbetsgivareArendetUrl } from "@/common/utils/composeArbetsgivareArendetUrl";
import type { SimpleArende } from "@/types/simpleArende";

import ArendeItem from "./ArendeItem.vue";
import ArendeSection from "./ArendeSection.vue";

export type ArendenListProps = {
  heading?: string;
  arenden: SimpleArende[];
  canShowMore: boolean;
  isLoading: boolean;
  showMoreTicketsButtonLabel: string;

  showMore: () => void;
};

const props = defineProps<ArendenListProps>();
</script>
